
import { Component, Prop, Vue } from 'vue-property-decorator';
import GradientExternalLinkIcon from '@/components/icons/GradientExternalLinkIcon.vue';
import BlockedIcon from '@/components/icons/BlockedIcon.vue';
import UIUtil from '@/utils/ui.util';

export interface ISectionCardData {
  link: string;
  title?: string;
  text?: string;
  customColors?: string[];
  fixedHeight?: number;
  externalLink?: boolean;
  blocked?: boolean;
  isNew?: boolean;
  active?: boolean;
  hiddenBlockedCard?: boolean;
}

@Component({
  components: {
    GradientExternalLinkIcon,
    BlockedIcon,
  },
})
export default class SectionCard extends Vue {
  @Prop([String, Array]) private title?: string | string[];
  @Prop(String) private text?: string;
  @Prop(String) private link!: string;
  @Prop(Array) private customColors?: string[];
  @Prop({ default: false }) private externalLink!: boolean;
  @Prop({ default: false }) private blocked!: boolean;
  @Prop({ default: false }) private isNew!: boolean;
  @Prop({ default: false }) private hiddenBlockedCard!: boolean;
  @Prop({ default: true }) private active!: boolean;

  isHovered = false;
  idSuffixGradientIcon: string = Math.random().toString(36).slice(2, 10);

  sanitizeText(value?: string | null): string {
    if (value == null) return '';
    const trimmed = String(value).trim();
    if (!trimmed) return '';
    const lowered = trimmed.toLowerCase();
    return lowered === 'undefined' || lowered === 'null' ? '' : trimmed;
  }

  get cardTitle(): string {
    if (!this.title) return '';
    if (Array.isArray(this.title)) {
      return this.sanitizeText(this.title[0]);
    }
    return this.sanitizeText(this.title);
  }

  get cardSubtitles(): string[] {
    if (!Array.isArray(this.title)) return [];
    return this.title
      .slice(1)
      .map((subtitle) => this.sanitizeText(subtitle))
      .filter((subtitle) => !!subtitle);
  }

  get safeText(): string {
    return this.sanitizeText(this.text);
  }

  generateGradient(colorArray: string[]): string {
    return UIUtil.generateGradient(colorArray);
  }

  goToLink(link: string, blocked = false, externalLink = false): void {
    if (blocked) return;
    if (externalLink) {
      window.open(link, '_blank');
    } else {
      this.$router.push(link);
    }
  }
}
